import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2, RefreshCw } from "lucide-react";

const FIELDS = [["apple", "Apple Podcasts"], ["spotify", "Spotify"], ["amazon", "Amazon Music"], ["youtube", "YouTube Music"]];

export default function PodcastAdmin() {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/podcast/links").then(({ data }) => setS(data));
  useEffect(() => { load(); }, []);
  if (!s) return <Loader2 className="h-5 w-5 animate-spin" />;
  const refresh = async () => {
    setBusy(true);
    try { const { data } = await api.post("/admin/podcast/refresh"); toast.success(`Podcast updated — ${data.episodes} episode${data.episodes === 1 ? "" : "s"}${data.new ? `, ${data.new} new (alert emails sending)` : ""}`); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Refresh failed"); } finally { setBusy(false); }
  };
  const save = async () => {
    try { const { data } = await api.put("/admin/podcast/links", s); setS(data); toast.success("Links saved"); }
    catch (e) { toast.error(e?.response?.data?.detail || "Couldn't save"); }
  };
  return (
    <div className="space-y-4 rounded-xl border border-border bg-white p-4" data-testid="podcast-admin">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div>
          <h3 className="font-display text-lg font-bold text-sam-navy">Podcast</h3>
          <p className="text-xs text-sam-slate" data-testid="podcast-admin-status">{s.episodes} episodes · last updated {s.fetched_at ? new Date(s.fetched_at).toLocaleString() : "never"}. New episodes appear automatically within 30 minutes.</p>
          {s.last_error && <p className="text-xs text-sam-crimson">Last update problem: {s.last_error}</p>}
        </div>
        <Button onClick={refresh} disabled={busy} className="bg-sam-navy" data-testid="podcast-refresh">{busy ? <Loader2 className="h-4 w-4 mr-1 animate-spin" /> : <RefreshCw className="h-4 w-4 mr-1" />}Refresh now</Button>
      </div>
      <div className="grid gap-3 sm:grid-cols-2">
        {FIELDS.map(([k, label]) => (
          <div key={k}><Label className="text-xs">{label} link</Label><Input value={s[k] || ""} placeholder="https://… (leave blank to hide the button)" onChange={(e) => setS({ ...s, [k]: e.target.value })} data-testid={`podcast-link-${k}`} /></div>
        ))}
      </div>
      <Button onClick={save} className="bg-sam-crimson" data-testid="podcast-links-save">Save links</Button>
    </div>
  );
}
